import { useCallback, useEffect, useState } from 'react';
import { featureFlagsAPI } from '../services/api';
import { getApiErrorMessage } from '../utils/apiErrorMessage';
import { hasPermission } from '../utils/permissions';

export default function useFeatureFlags(user) {
  const canManage = hasPermission(user, 'feature_flags.manage');
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const load = useCallback(async () => {
    if (!canManage) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await featureFlagsAPI.list();
      setGroups(res.data?.data?.groups || []);
    } catch (err) {
      setError(getApiErrorMessage(err, 'Failed to load feature flags'));
    } finally {
      setLoading(false);
    }
  }, [canManage]);

  useEffect(() => {
    load();
  }, [load]);

  const updateFlag = async (key, patch) => {
    setSavingKey(key);
    setError('');
    setSuccess('');
    try {
      await featureFlagsAPI.update(key, patch);
      setSuccess('Feature flag updated');
      await load();
    } catch (err) {
      setError(getApiErrorMessage(err, 'Failed to update feature flag'));
    } finally {
      setSavingKey('');
    }
  };

  return {
    canManage,
    groups,
    loading,
    savingKey,
    error,
    success,
    updateFlag,
    reload: load,
  };
}
